module.exports = __webpack_public_path__ + "static/media/BW.aa5eb18d.png";